const SCORE_MIN = -60;
const SCORE_MAX = 200;
const CHALLENGE_THRESHOLD = 35;
const BLOCK_THRESHOLD = 70;

const FLAGS = {
  STOPWORDS: 1 << 0,
  REQUEST_RATE: 1 << 1,
  ASN_HOSTING: 1 << 2,
  BAD_ENCODING: 1 << 3,
  DOUBLE_ENCODED: 1 << 4,
  UA_TOOL: 1 << 5,
  SUBNET_RATE: 1 << 6,
  SUBNET_SWEEP: 1 << 7,
  ASN_RATE: 1 << 8,
  ASN_SWEEP: 1 << 9,
  SPOOFED_CRAWLER: 1 << 10,
  BAD_GEO: 1 << 11,
  REFERER_SUSPECT: 1 << 12,
  HEADER_INCONSISTENT: 1 << 13,
  // cron-only
  ENUMERATION: 1 << 14,
  HIGH_404: 1 << 15,
  ASN_FLAGGED: 1 << 16,
  REFERER_ROTATION: 1 << 17,
  // positive: bits 20-30
  CF_BOT: 1 << 26,
  ASN_EYEBALL: 1 << 27,
  RAN_JS: 1 << 28,
  AUTHENTICATED: 1 << 29,
  VERIFIED_CRAWLER: 1 << 30,
};

const WEIGHTS = {
  STOPWORDS: 40,
  REQUEST_RATE: 25,
  ASN_HOSTING: 15,
  BAD_ENCODING: 20,
  DOUBLE_ENCODED: 20,
  UA_TOOL: 30,
  SUBNET_RATE: 25,
  SUBNET_SWEEP: 40,
  ASN_RATE: 15,
  ASN_SWEEP: 20,
  SPOOFED_CRAWLER: 80,
  BAD_GEO: 30,
  REFERER_SUSPECT: 20,
  HEADER_INCONSISTENT: 20,
  ENUMERATION: 35,
  HIGH_404: 30,
  ASN_FLAGGED: 35,
  REFERER_ROTATION: 40,
  CF_BOT: -30,
  ASN_EYEBALL: -10,
  RAN_JS: -25,
  AUTHENTICATED: -60,
  VERIFIED_CRAWLER: -80,
};

export {
  SCORE_MIN,
  SCORE_MAX,
  CHALLENGE_THRESHOLD,
  BLOCK_THRESHOLD,
  FLAGS,
  WEIGHTS,
};
